import { apiClient, handleApiRequest } from './client'
import type { ConflictLogItem, ConflictScanResult, ConflictConfigSummary } from '@/types/admin5'

export interface ConflictLogListResponse {
  logs: ConflictLogItem[]
  pagination: {
    page: number
    page_size: number
    total_items: number
    total_pages: number
  }
}

export const conflictsApi = {
  listConflicts: (params?: {
    conflict_type?: string
    severity?: string
    is_resolved?: boolean
    page?: number
    page_size?: number
  }) => {
    const qs = new URLSearchParams()
    if (params?.conflict_type) qs.set('conflict_type', params.conflict_type)
    if (params?.severity) qs.set('severity', params.severity)
    if (params?.is_resolved !== undefined) qs.set('is_resolved', String(params.is_resolved))
    if (params?.page) qs.set('page', String(params.page))
    if (params?.page_size) qs.set('page_size', String(params.page_size))
    const query = qs.toString()
    return handleApiRequest<ConflictLogListResponse>(
      apiClient.get(`/api/v1/conflicts/logs${query ? `?${query}` : ''}`),
    )
  },

  resolveConflict: (logId: string, resolutionMethod: string, resolutionNotes?: string) =>
    handleApiRequest(
      apiClient.post(`/api/v1/conflicts/logs/${logId}/resolve`, {
        resolution_method: resolutionMethod,
        resolution_notes: resolutionNotes,
      }),
    ),

  bulkScan: (params?: { date_from?: string; date_to?: string; check_dimensions?: string[] }) => {
    const today = new Date()
    const in14 = new Date(today.getTime() + 14 * 24 * 60 * 60 * 1000)
    const date_from = params?.date_from || today.toISOString().slice(0, 10)
    const date_to = params?.date_to || in14.toISOString().slice(0, 10)
    return handleApiRequest<ConflictScanResult>(
      apiClient.post('/api/v1/conflicts/bulk-scan', {
        date_from,
        date_to,
        check_dimensions: params?.check_dimensions || ['teacher', 'substitution'],
      }),
    )
  },

  getConfig: () =>
    handleApiRequest<ConflictConfigSummary>(
      apiClient.get('/api/v1/conflicts/config'),
    ),
}
